import { t } from 'i18next'
import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '@/features/authentication/contexts/AuthContext'
import { hasRevenuePermissions } from '@/features/authorization/permissionHandlers/revenuePermissions'
import { SiteRevenueContent } from '@/features/site/components/revenue/SiteRevenueContent'
import { useRevenueTabsData } from '@/features/site/hooks/useRevenueTabsData'
import { SiteDetailsRouteInformation } from '@/features/site/pages/constants'
import { useSiteDetails } from '@/features/site/pages/SiteDetails'

export function SiteDetailsRevenue() {
  const { loggedInUser } = useAuth()
  const { site, isFetchingSite, setPageConfig, siteDetailsCommonBreadcrumbs } = useSiteDetails()
  const { isLoading, insightRevenuePeriods, legacyRevenuePeriods, marketPrograms, hasRevenueData, hasLegacyData } =
    useRevenueTabsData({ site })

  useEffect(() => {
    setPageConfig({
      title: t('customer_details.tabs.revenue.title'),
      breadcrumbs: siteDetailsCommonBreadcrumbs,
      pageTag: 'site-details-revenue',
      activeTab: SiteDetailsRouteInformation.REVENUE.navigationPath,
    })
  }, [])

  if (!loggedInUser || !hasRevenuePermissions({ loggedInUser, site })) {
    return <Navigate replace to={`/sites/${site.uuid}/contact-info`} />
  }

  if (!site || isFetchingSite || isLoading) {
    return null
  }

  return (
    <SiteRevenueContent
      hasLegacyData={hasLegacyData}
      hasRevenueData={hasRevenueData}
      insightRevenuePeriods={insightRevenuePeriods}
      legacyRevenuePeriods={legacyRevenuePeriods}
      marketPrograms={marketPrograms}
      site={site}
    />
  )
}
